<template>
    <div class="modal-goodslist">
        <div class="modal">
            <div class="modal-header">
                <div style="padding: 6px;">购物车</div>
                <button type="button" class="btn-close" @click="closeSelf">关闭</button>
            </div>
            <div class="modal-body" style="padding:0px">
                <el-row>
                    <el-card class="box-card" shadow="never">
                        <div slot="header" class="clearfix">
                            <span>购物车商品</span>
                        </div>
                        <el-col :span="24">
                            <el-table
                                :data="cartInfo"
                                style="width: 100%" border stripe max-height='450'>
                                <el-table-column prop="listCartGoodsStaffDTO[0].goodsName" label="标题" width="150"></el-table-column>
                                <el-table-column prop="listCartGoodsStaffDTO[0].goodsHead" label="商品图片" width="100">
                                    <template slot-scope="scope">
                                        <el-popover placement="right" title="" trigger="click" v-if="imgUrl+scope.row.listCartGoodsStaffDTO[0].goodsHead">
                                            <img :src="imgUrl+scope.row.listCartGoodsStaffDTO[0].goodsHead"  style="width: 500px"/>
                                            <img slot="reference" :src="imgUrl+scope.row.listCartGoodsStaffDTO[0].goodsHead" style="width:100%">
                                        </el-popover>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="listCartGoodsStaffDTO[0].goodsPriceSale" label="销售价（元）"></el-table-column>
                                <el-table-column prop="listCartGoodsStaffDTO[0].number" label="购买数量"></el-table-column>
                                <el-table-column prop="listCartGoodsStaffDTO[0].planTime" :formatter="timefilter" width="200" label="预约时间"></el-table-column>
                                <el-table-column label="操作">
                                    <template slot-scope="scope">
                                        <el-button type="primary" size="small" @click="handleCartEdit(scope.$index, scope.row)">编辑</el-button>
                                        <el-button type="danger" size="small" @click.native.prevent="handleDelete(scope.$index, scope.row)">删除</el-button>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </el-col>
                    </el-card>
                    <el-card class="box-card" shadow="never" :body-style="cardBodyStyle">
                        <div slot="header" class="clearfix">
                            <span>收货地址</span>
                        </div>
                        <el-col :span="24" class="item">
                            <el-table
                                :data="addressInfo"
                                style="width: 100%;" border stripe max-height='450' v-if="addressInfo.length>0">
                                <el-table-column prop="receiveName" label="名称" width="150"></el-table-column>
                                <el-table-column prop="receivePhone" label="手机号"></el-table-column>
                                <el-table-column prop="areaNamePath" label="地区"></el-table-column>
                                <el-table-column prop="receiveAddress" width="200" label="详细地址"></el-table-column>
                                <el-table-column label="操作">
                                    <template slot-scope="scope">
                                        <el-button type="primary" size="small" @click="showAddress(scope.$index, scope.row)">更换</el-button>
                                    </template>
                                </el-table-column>
                            </el-table>
                            <el-button type="primary" v-if="addressInfo.length==0" style="width:30%;margin-bottom:20px;" @click="showAddress">选择地址</el-button>
                        </el-col>
                    </el-card>
                </el-row>

            </div>
            <div class="modal-footer">
                <el-button :loading="loading" type="primary" @click="confirm()">提交</el-button>
            </div>
        </div>
        <CartEdit ref="myCartEdit" v-show="showModalCartEdit" v-on:closeCartEdit="closeCartEdit" v-on:getGoods="getGoods"></CartEdit>
        <Address ref="myAddress" v-show="showModalAddress" v-on:closeAddress="closeAddress" v-on:setAddress="setAddress"></Address>
    </div>
</template>

<script>

    import {timeStr,timefilters} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";
    import {getStaffCode} from "@/utils/auth";
    import CartEdit from "./CartEdit"
    import Address from "./Address"

    export default {
        name: 'GetGood',
        data() {
            return {
                showModalCartEdit:false,
                showModalAddress:false,
                loading: false,
                cartInfo:[],
                cardBodyStyle:{'text-align':'center'},
                addressInfo:[],
                imgUrl:this.$imgUrl,
                elderly:'',
                userAddressCode:'',
                totalItems:0,
                elderlyCode:''
            }
        },
        components:{
            CartEdit,Address
        },
        methods: {
            init(row){
                this.addressInfo=[]
                this.elderlyCode=row.elderlyCode
                this.getGoods()
            },
            closeSelf() {
                this.$emit("closeCart");
            },
            handleCartEdit(index, row) {
                row.listCartGoodsStaffDTO[0].planTime=timefilters(row.listCartGoodsStaffDTO[0].planTime);
                this.$refs.myCartEdit.init(row.listCartGoodsStaffDTO[0],this.elderlyCode,row.goodsType);
                this.showModalCartEdit = !this.showModalCartEdit;
            },
            handleDelete(index, row){
                this.$confirm('此操作将删除此商品, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$axios({
                        method: 'post',
                        url: this.$shopUrl+"AppCare/CartStaffItemDelete",
                        data: {
                            sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                            timeStr:timeStr,
                            staffCode:getStaffCode(),
                            cartGoodsStaffCode:row.listCartGoodsStaffDTO[0].cartGoodsStaffCode,
                            elderlyCode:this.elderlyCode,
                        }
                    }).then(
                        (response) => {
                            this.loading = false;
                            if (response.data.error == 0) {
                                this.getGoods();
                               this.$message({
                                    type: 'success',
                                    message: '删除成功!'
                                });
                            }else if(response.data.error == 1){
                                this.$message.error(response.data.message)
                            }
                        }
                    )
                    
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });          
                });
            },
            showAddress(){
                this.$refs.myAddress.init(this.elderlyCode);
                this.closeAddress()
            },
            setAddress(address){
                this.addressInfo=[]
                this.addressInfo.push(address);
                this.userAddressCode=address.userAddressCode
            },
            confirm(){
                this.loading=true;
                this.$axios({
                    method: 'post',
                    url: this.$shopUrl+"AppCare/CartStaffSubmit",
                    data: {
                        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        timeStr:timeStr,
                        staffCode:getStaffCode(),
                        userAddressCode:this.userAddressCode,
                        payType:'gov',
                        clientType:'pcadm',
                        elderlyCode:this.elderlyCode
                    }
                }).then(
                    (response) => {
                        this.loading = false;
                        if (response.data.error == 0) {
                            this.closeSelf();
                            // this.$emit("closeCart");
                            this.$emit("getList");
                        }else if(response.data.error == 1){
                            this.$message.error(response.data.message)
                        }
                    }
                )
            },
            //日期格式
            timefilter(row){
                return timefilters(row.listCartGoodsStaffDTO[0].planTime)
            },
            closeCartEdit:function(){
                this.showModalCartEdit = !this.showModalCartEdit;
            },
            closeAddress:function(){
                this.showModalAddress = !this.showModalAddress;
            },
            getGoods(){
                this.$axios({
                    method: 'post',
                    url: this.$shopUrl+"AppCare/CartStaff",
                    data: {
                        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        timeStr:timeStr,
                        staffCode:getStaffCode(),
                        elderlyCode:this.elderlyCode
                    }
                }).then(
                    (response) => {
                        this.loading = false;
                        if (response.data.error == 0) {
                            this.cartInfo=response.data.data.cartStaffDTO.listCartBusinessStaffDTO;
                        }else if(response.data.error == 1){
                            this.$message.error(response.data.message)
                        }
                    }
                )
            },
        }
    }


</script>





<style lang="scss" scoped>

    .modal-goodslist {
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        background-color: rgba(0,0,0,.3);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 99;

        .modal {
            background-color: #fff;
            box-shadow:  0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
            overflow-x:auto;
            display: flex;
            flex-direction: column;
            border-radius: 10px;
            width: 1000px;

            .modal-header {
                border-bottom: 1px solid #eee;
                color: #313131;
                justify-content: space-between;
                padding: 10px;
                display: flex;
            }
            .modal-body .box-card{
                margin-bottom:20px;
                border-bottom: none;
            }
            .modal-body {
                position: relative;
                padding: 20px 0px;
                z-index: 99;
                overflow-y:scroll;
                height:570px;
            }
            .modal-footer {
                border-top: 1px solid #eee;
                justify-content: flex-end;
                padding: 15px 40px;
                display: flex;
            }


        }

    }
    

    .btn-close, .btn-confirm {
        border-radius: 8px;
        margin-left:16px;
        width:56px;
        height: 36px;
        border:none;
        cursor: pointer;
    }
    .btn-close {
        color: #313131;
        background-color:transparent;
    }



    .row{
        padding: 10px 0px;
    }
    .item{
        padding: 0px 20px;
    }
    .label{
        padding: 5px 0px;
    }


</style>
